"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var shuffleArray_1 = __importDefault(require("../shuffleArray"));
/**
 * Randomly select an element from
 * an array.
 */
function selectRandomArrayElement(array) {
    var shuffled = shuffleArray_1.default(array);
    return shuffled.slice(0, 1)[0];
}
exports.default = selectRandomArrayElement;
//# sourceMappingURL=selectRandomArrayElement.js.map